import { combineReducers } from "redux";
import Action from "../actions/types";
import { object } from "./generators";

export default combineReducers({
  data: object(Action.HISTOGRAM_UPDATE_DATA, {
    scores: []
  })
});
